import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { serviceOpsInvoicingActions } from '../../_actions';
import DataTable from '_components/Tables/DataTable';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import Accordion from '@mui/material/Accordion';
import { Box, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import SelectWithLabel from '_components/FormFields/SelectWithLabel';
import { useDropzone } from 'react-dropzone'
import * as XLSX from 'xlsx';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import SuiButton from '_softUI/components/SuiButton';
import CustomToolbar from '../../_components/Tables/EditableTable/CustomToolbar';
import { arrayBufferToBase64 } from '_helpers/file'
import {
    GridToolbarQuickFilter,
    GridToolbarDensitySelector,
    GridToolbarExport,
} from '@mui/x-data-grid';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import AccordionSummary from '@mui/material/AccordionSummary';
import BillingInformationComparison from '_components/Admin/ServiceOps/BillingInformationComparison';
import VisibilityIcon from '@mui/icons-material/Visibility';


export default function AdminInvoicingTab() {

    const [selectionModel, setSelectionModel] = useState([]);
    const [columnVisibility, setColumnVisibility] = useState({})
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);

    const dispatch = useDispatch();
    const state = useSelector(state => state.serviceOpsInvoicing)

    const invoiceRows = useSelector(state => state.serviceOpsInvoicing.invoicingInformation.rows) ?? [];
    const carrier = useSelector(state => state.serviceOpsInvoicing.invoicingInformation.selectedCarrier);

    console.log(selectionModel)


    const options = [
        { value: 'DHL', label: 'DHL' },
        { value: 'DSV', label: 'DSV' },
        { value: '108', label: 'Posti' },
        { value: 'FEDEX', label: 'FEDEX' },
        { value: 'UPS', label: 'UPS' },
        { value: 'POSTNORD', label: 'POSTNORD' },
    ]



    const handleUpdate = (updatedRow) => {
        console.log('Dispatching update for:', updatedRow);
        dispatch(serviceOpsInvoicingActions.updateRowValue(updatedRow));
        return updatedRow;
    };

    const handleFile = (e) => {

        const reader = new FileReader()
        const file = e.target.files[0];
        reader.onload = (event) => {
            const binary = event.target.result;
            const entry = {
                name: file.name,
                data: arrayBufferToBase64(binary),
                type: file.type,

            }

            dispatch(serviceOpsInvoicingActions.setDataFromExcel(entry));
        }

        reader.readAsArrayBuffer(file)
    }

    const handleProcess = () => {

        dispatch(serviceOpsInvoicingActions.processInvoicingData(state.data, carrier))
        setSelectionModel([])

    };

    function handleSelectChange(event, name) {
        dispatch(serviceOpsInvoicingActions.updateCarrierForInvoicing(name, event.value));
    }

    const addPricesToShipments = () => {
        const result = selectionModel.map(selectedId => {
            const selectedRow = invoiceRows.find(row => row.shipmentId === selectedId)
            console.log(selectedRow)
            return {
                shipmentId: selectedId,
                price: selectedRow ? selectedRow.totalPrice : null,
                items: selectedRow.items
            }
        })
        dispatch(serviceOpsInvoicingActions.addPricesToShipments(result))
    }

    const handleViewClick = (id) => () => {
        const row = data.rows.find((row) => row.id === id);
        setSelectedRow(row);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedRow(null);
    };

    const data = {
        columns: [
            { headerName: "Id", field: "shipmentId" },
            { headerName: "Tracking number", field: "trackingNumber", flex: 1 },
            { headerName: "Customer price", field: "customerPrice" },
            { headerName: "Expected price", field: "expectedPrice" },
            { headerName: "Actual Price", field: "actualPrice", editable: true, },
            { headerName: "Profit", field: "profit" },
            { headerName: "Margin", field: "margin" },
            {
                headerName: "Status", field: "action",
                renderCell: (params) => {
                    let chipColor;
                    let title;
                    if (params.row.error) {
                        chipColor = "error"
                        title = params.row.errorMessage
                    }
                    else if (((params.row.customerPrice - params.row.actualPrice) < 0)) {
                        chipColor = "error"
                        title = "Turskaa"
                    }
                    else if (((params.row.customerPrice - params.row.actualPrice) / params.row.customerPrice) * 100 < 14) {
                        chipColor = "warning"
                        title = "Tarkista marginaali"
                    }
                    else {
                        chipColor = "success"
                        title = "$$$"
                    }
                    return (
                        <Tooltip title={<BillingInformationComparison actual={params.row.items ?? []} expected={params.row.expectedItems ?? []} />}>
                            <Chip color={chipColor} label={title} size="small" sx={{ minWidth: '50px', height: '20px' }} />
                        </Tooltip>
                    )
                },
                flex: 2,
            },
            {
                headerName: '',
                align: 'center',
                field: 'select',
                width: 100,
                renderCell: (params) => (
                    <Checkbox
                        checked={selectionModel.includes(params.id)}
                        onChange={(event) => {
                            const newSelection = event.target.checked
                                ? [...selectionModel, params.id]
                                : selectionModel.filter(id => id !== params.id);
                            setSelectionModel(newSelection);
                        }}
                    />
                )
            },
            {
                field: 'actions',
                type: 'actions',
                headerName: 'Actions',
                width: 100,
                getActions: ({ id }) => [
                    <GridActionsCellItem
                        icon={<VisibilityIcon />}
                        label="View"
                        onClick={handleViewClick(id)}
                        color="inherit"
                    />
                ]
            }
        ],
        rows: invoiceRows.map((x, i) => ({
            id: i,
            shipmentId: x.shipmentId,
            trackingNumber: x.trackingId,
            billingWeight: x.billingWeight,
            customerPrice: x.customerPrice.toFixed(2),
            expectedPrice: x.expectedTotalPrice.toFixed(2),
            actualPrice: x.totalPrice.toFixed(2),
            profit: x.totalPrice > 0 ? (x.customerPrice - x.totalPrice).toFixed(2) + ' €' : 'n/a',
            margin: x.totalPrice > 0 ? (((x.customerPrice - x.totalPrice) / x.customerPrice) * 100).toFixed(2) + ' %' : 'n/a',
            errorMessage: x.errorMessage,
            error: x.error,
            items: x.items,
            expectedItems: x.expectedItems
        }))
    }



    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="stretch"

            sx={{ height: 'calc(100%)' }}>



            <Grid container item xs={12} sx={{ height: '100%' }} >
                <Paper sx={{ width: '100%', height: '100%' }}>
                    <Grid container item xs={12} mb={4}>

                        <Grid item xs={3} mt={4}>

                            <input
                                type="file"
                                accept=".csv"
                                onChange={handleFile}
                            />

                        </Grid>
                        <Grid item xs={3} >
                            <SelectWithLabel label="Carrier" options={options} onChange={e => handleSelectChange(e, 'countryId')}>
                            </SelectWithLabel>
                        </Grid>
                        <Grid item xs={3} display='flex' alignItems='flex-end' ml={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleProcess}
                                style={{ marginTop: '16px' }}
                            >
                                Process Input
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container direction="row" justifyContent="flex-start" alignItems="stretch" sx={{ height: '100%' }}>
                        <Grid container item xs={12} sx={{ height: '100%' }}>
                            <Paper sx={{ width: '100%', height: '100%' }}>
                                <DataGrid
                                    rowHeight={38}
                                    rows={data.rows}
                                    columns={data.columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 100,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[100]}
                                    sx={{ fontSize: '12px' }}
                                    columnVisibilityModel={columnVisibility}
                                    processRowUpdate={(newRow) => {
                                        const updatedRow = { ...newRow };
                                        handleUpdate(updatedRow);

                                        return updatedRow;
                                    }}
                                    slots={{
                                        toolbar: () => (
                                            <>
                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
                                                    <Box display='flex' alignItems='center'>
                                                        <Button onClick={() => addPricesToShipments()}>Accept all selected</Button>

                                                    </Box>
                                                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                        <Box display='flex' alignItems='center'>
                                                            <GridToolbarDensitySelector />
                                                            <GridToolbarExport />
                                                        </Box>
                                                        <Box >


                                                            <GridToolbarQuickFilter />
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </>
                                        )
                                    }}


                                />
                            </Paper>

                        </Grid>
                    </Grid>




                </Paper>
            </Grid>
            <Dialog open={modalOpen} onClose={handleModalClose} maxWidth="md" fullWidth>
                <DialogTitle>Row Details</DialogTitle>
                <DialogContent>
                    <Box sx={{ p: 2 }}>

                    </Box>
                </DialogContent>
                <DialogActions>
                    <SuiButton onClick={handleModalClose} color="primary">
                        Close
                    </SuiButton>
                </DialogActions>
            </Dialog>
        </Grid>
    )

}